import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface WebhookForwardItem {
  forward_id: string;
  url: string;
  event_types: string[];
  headers?: Record<string, string>;
  enabled: boolean;
  created_at: number;
  updated_at: number;
}

type QueryResponse = {
  status: number;
  data: {
    forwards: WebhookForwardItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListWebhookForwardsKey = (additional: any[] = []) => [
  'list-webhook-forwards',
  ...additional,
];

export const useListWebhookForwardsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing webhook forwards',
    endpoint: `/api/admin/whatsapp/webhook-forwards`,
  });

  return useQuery({
    queryKey: createListWebhookForwardsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
